import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from '@/services/api/axios-base-query';

export const baseApi = createApi({
  reducerPath: 'api',
  baseQuery: axiosBaseQuery(),
  tagTypes: [
    'Auth',
    'Profile',
    'Guest',
    'Restaurant',
    'RestaurantHour',
    'RestaurantTable',
    'Reservation',
    'DailyNote',
    'Rate',
    'Configuration',
    'User',
    'Role',
    'Dashboard',
    'Client',
    'ClientConfiguration',
    'Log',
    'Report',
    'ReservationConfiguration',
    'ChildCategory',
    'ReservationStatus',
    'Template',
    'SmtpSetting',
    'RecaptchaSetting',
  ],
  endpoints: () => ({}),
});
